import { Content } from '../models/content';

export const frenchContent: Content = {
  translation: {
    title:
      'Opérateur de pool de staking Cardano basé en Europe<br /> pensé et réalisé par <a href="mailto:adapool_charles@pm.me">@Charles</a> et <a href="mailto:adapool_mikael@pm.me">@Mika</a>.',
    whoAreWe: 'Qui sommes-nous ?',
    whyJoinUs: 'Pourquoi s’engager avec nous ?',
    poolDetails: 'Les détails du pool',
    s1: {
      p1: 'Nous sommes Charles 😊 et Mika 😉, un partenariat de deux Toulousains motivés à démocratiser l’usage des crypto-monnaies.',
      p2: 'Mika, qui aide les administrations dans leurs transformations numériques, apporte son expérience technique et humaine. Charles met à profit plus d’une décennie d’expérience dans le domaine de l’ingénierie logiciel. Ensemble nous participons avec enthousiasme au développement du réseau Cardano !',
      p3: 'Nous sommes impliqués dans les cryptomonnaies depuis 2017, nous avons eu la chance de faire un profit au sommet du marché. C’est à ce moment que nous avons découvert le projet Cardano et, depuis, nous le suivons avec un vif intérêt.',
      p4: 'Notre objectif avec ADA Pool Europe est de créer une communauté de personnes partageant nos valeurs, qui croient en Cardano et à laquelle nous offrons une bonne expérience de mise en commun de capitaux.',
    
    },
    s2: {
      p1: 'Nous sommes motivés à démocratiser l’usage des crypto-monnaies.',
      p2: ' infrastructure de haute disponibilité',
      p3: ' avec des frais limités',
      p4: ' ouvert au plus grand nombre',
      p5: ' serveurs dédiées et sécurisées',
      p6: 'Notre pool de staking Cardano basé en Europe se consacre au renforcement et à la décentralisation du réseau Cardano.<br> Nous offrons un staking de haute disponibilité, fiable et sécurisé basé sur deux noeuds relais et un noeud producteur en centres-serveurs de qualité professionnelle. Notre objectif est de créer une bonne expérience de participation.',
      p7: "	Nous mettons un fort accent sur la performance et la sécurité de notre infrastructure de pool. Nous souhaitons également permettre au plus grand nombre d’entre vous de participer à l’aventure crypto.",
      p8: 'En stakant vos ADA dans notre pool vous participez au fonctionnement du réseau Cardano.',   
    p9:'	✔&nbsp;Vos ADA ne sont jamais bloqués, vous pouvez les transférer n’importe quand et sans pénalité&nbsp;;<br><br>✔&nbsp;Vos ADA ne vous quittent jamais, vous ne pouvez pas les perdre par la méthode du “staking”&nbsp;;<br><br>✔&nbsp;Vos récompenses sont automatiquement réinvesties, tous les 5 jours vous recevez votre part des gains qui sont automatiquement stackés&nbsp;;<br><br>✔&nbsp;Vous pouvez commencer à stacker vos ADA même si vous en avez très peu.',
    },
    s3:{
      p1:'Pour participer au fonctionnement du réseau Cardano, rien de plus simple !<br>Il vous suffit de staker vos crypto-monnaies ADA dans notre pool "adapool-europe".',
      p2:'Identifiant à saisir pour déléguer vos ADA&nbsp;:',
      p3:'Widget interactif',
      p4:'Pledge',
      p5:'Propriétaires :',
      p6:'Valeur du pledge&nbsp;:',
      p7:'Stake',
      p8:'Délégataires :',
      p9:'Valeur du stake&nbsp;:',
      p10:'Frais appliqués',
      p11:'Frais variables&nbsp;:',
      p12:'Frais fixes&nbsp;:',
      p13:'Cours de la crypto-monnaie'
    },footer:{p1:'Nous contacter'}
  },
};
